module.exports = __webpack_public_path__ + "img/2.551191bc.jpg";